import { jsx as i, Fragment as m } from "react/jsx-runtime";
import { Chip as p } from "@mui/material";
import { D as a, b as l } from "../../pointsGraph-DTJju-rA.js";
const f = ({ resources: n }) => {
  const t = n == null ? void 0 : n.filter((o) => o.ResourceType === 1);
  return !t || t.length === 0 ? null : /* @__PURE__ */ i(m, { children: t.map((o) => /* @__PURE__ */ i(p, { size: "small", label: o.Description, icon: /* @__PURE__ */ i(a, { iconType: l.Location }) }, o.Id)) });
};
export {
  f as EventRooms
};
//# sourceMappingURL=EventRooms.js.map
